import { SET_MOBILE_NOTIFICATION_OPT_IN } from 'actions';

export function setMobileNotificationOptIn(mobileNotificationOptIn?: boolean) {
  return { mobileNotificationOptIn, type: SET_MOBILE_NOTIFICATION_OPT_IN };
}
